export const getters = {
    //
};
